import { render, staticRenderFns } from "./promotemarketSystem.vue?vue&type=template&id=71c654a2&scoped=true"
import script from "./promotemarketSystem.vue?vue&type=script&lang=js"
export * from "./promotemarketSystem.vue?vue&type=script&lang=js"
import style0 from "./promotemarketSystem.vue?vue&type=style&index=0&id=71c654a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c654a2",
  null
  
)

export default component.exports